/* eslint-disable react/prop-types */
import { Close } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import characterStore from "../../../store/CharactersStore";
import { TransparentButton } from "../../Button/TransparentButton";
import { DialogWrapper } from "../../Dialog";
import { Title } from "../../molecules/header";
import CharacterForm from "./characterForm";
import { STEP } from "./constant";
import { HumanList } from "./HumanList";
import humanIllustration from "../../../assets/humanIllustration.webp";
import othersIllustration from "../../../assets/othersIllustration.webp";
import useUserDetailsStore from "../../../store/UserStore";
import toast from "react-hot-toast";

const CharacterDialog = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const [
    selectedCharacterForEdit,
    activeView,
    setActiveView,
    setSelectedKidForCharacter,
  ] = characterStore((state) => [
    state.selectedCharacterForEdit,
    state.activeView,
    state.setActiveView,
    state.setSelectedKidForCharacter,
  ]);
  const canAddHuman = useUserDetailsStore((state) => state.canAddHuman);

  const VIEW = {
    [STEP.SELECT_CHARACTER_TYPE]: {
      title: <Title>Add Character</Title>,
      content: (
        <div className="my-8 flex justify-center gap-8 w-full m-auto ">
          <div>
            <div
              onClick={() => setActiveView(STEP.SELECT_HUMAN)}
              className="rounded-full h-[150px] w-[150px] overflow-hidden drop-shadow-md transition-all ease-in-out duration-300 hover:scale-105 hover:drop-shadow-[0px_10px_10px_rgba(60,195,170,0.50)]"
            >
              <img src={humanIllustration} alt="placeholder" />
            </div>
            <p className="font-bold text-center pt-4">Human</p>
          </div>
          <div>
            <div
              onClick={() => setActiveView(STEP.CHARACTER_FROM_OTHERS)}
              className="rounded-full h-[150px] w-[150px] overflow-hidden drop-shadow-md transition-all ease-in-out duration-300 hover:scale-105 hover:drop-shadow-[0px_10px_10px_rgba(60,195,170,0.50)]"
            >
              <img src={othersIllustration} alt="placeholder" />
            </div>
            <p className="font-bold text-center pt-4">Others</p>
          </div>
        </div>
      ),
    },
    [STEP.SELECT_HUMAN]: {
      title: <Title>Based On Existing</Title>,
      content: (
        <div className="h-[70vh] p-8 pb-4 relative">
          <HumanList />
          <Tooltip
            placement="top"
            title={
              canAddHuman ? "" : "You have reached the limit of adding human."
            }
            arrow
          >
            <div className="pt-2 absolute bottom-2">
              <TransparentButton
                disabled={!canAddHuman}
                handleButtonClick={() => {
                  if (canAddHuman) return navigate("/add-human");
                  toast("You have reached the limit of adding human.");
                }}
                style={{ margin: "0" }}
                className="rounded-lg "
              >
                Add New
              </TransparentButton>
            </div>
          </Tooltip>
        </div>
      ),
    },
    [STEP.ADD_CHARACTER]: {
      title: <Title>Edit Character</Title>,
      content: (
        <CharacterForm
          characterDetails={selectedCharacterForEdit}
          onClose={handleClose}
        />
      ),
    },
    [STEP.CHARACTER_FROM_HUMAN]: {
      title: <Title>Character From Human</Title>,
      content: <CharacterForm type="human" onClose={handleClose} />,
    },
    [STEP.CHARACTER_FROM_OTHERS]: {
      title: <Title>Character From Others</Title>,
      content: <CharacterForm type="others" onClose={handleClose} />,
    },
  };
  function handleClose() {
    onClose();
    setActiveView(STEP.SELECT_CHARACTER_TYPE);
  }
  console.log("activeView", activeView);
  return (
    <DialogWrapper
      className={
        activeView !== STEP.SELECT_HUMAN ? "max-w-[558px]" : "max-w-[1024px]"
      }
      isOpen={isOpen}
      onClose={handleClose}
      header={
        <div className="relative">
          <div className="flex justify-center pt-4">
            {VIEW[activeView].title}
          </div>
          <div className="absolute top-0 right-0 grid justify-items-end">
            <IconButton onClick={handleClose}>
              <Close />
            </IconButton>
          </div>
        </div>
      }
    >
      {VIEW[activeView].content}
    </DialogWrapper>
  );
};
export default CharacterDialog;
